import React from 'react'
import { Minus, Plus } from 'react-feather'

const FormDashboardInputNumber = ({placeholder, onChange, className, defaultValue}) => {
  const [value, setValue] = React.useState(defaultValue || 0)

  const handleChange = (e) => {
    setValue(e.target.value)
  }

  return (
    <div
      className={`custom-input-number text-sm rounded border bg-white flex justify-between items-center ${className}`}
      style={{borderColor: '#ddd'}}
    >
      <div className="p-2 lg:pl-4 cursor-pointer" onClick={() => setValue(value-1)}>
        <Minus style={{width: '12px', height: '12px'}}/>
      </div>
      <input
        className="py-2 lg:p-2 w-full text-center"
        placeholder={placeholder}
        onChange={handleChange}
        type="number"
        value={value}
      />
      <div className="p-2 lg:pr-4 cursor-pointer" onClick={() => setValue(value+1)}>
        <Plus style={{width: '12px', height: '12px'}}/>
      </div>
    </div>
  )
}

export { FormDashboardInputNumber }